import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import {
	Container,
	Image,
	ImageIcon,
	P
} from './styles';

const BuildingImage = props => {
	const { t } = props;
	const images = props.images.map((image, i) => (
		<Image key={i} image={image ? image.conversions.small : ''} />
	));

	return (
		<Container onClick={props.viewImagesToggleHandler}>
			{images}
			<P>{t('building/images/browse images')} <ImageIcon icon="photo" /></P>
		</Container>
	)
};

BuildingImage.propTypes = {
	t: PropTypes.func,
	images: PropTypes.array,
	viewImagesToggleHandler: PropTypes.func,
}

export default translate('translations')(BuildingImage)
